module.exports = require("core-js-pure/features/array/is-array");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/array/is-array.js
// module id = 503
// module chunks = 0 1